import { TrainingStatus } from './data-sources.enums';

export const CONFIGS_BY_TRAINING_STATUS: Record<
  TrainingStatus,
  { [key: string]: string }
> = {
  [TrainingStatus.Ready]: {
    label: 'data-sources.training-status.ready',
    icon: 'forward',
    bgColor: '#dbeafe',
    border: '#1a8dce',
    iconColor: '#0554e3',
    textColor: '#0554e3',
  },
  [TrainingStatus.InProgress]: {
    label: 'data-sources.training-status.in-progress',
    icon: 'sync',
    bgColor: '#ffedd5',
    border: '#e78129',
    iconColor: '#9a3412',
    textColor: '#9a3412',
  },
  [TrainingStatus.Completed]: {
    label: 'data-sources.training-status.completed',
    icon: 'check',
    bgColor: '#dcfce7',
    border: '#27ae60',
    iconColor: '#166534',
    textColor: '#166534',
  },
  [TrainingStatus.Failed]: {
    label: 'data-sources.training-status.failed',
    icon: 'close',
    bgColor: '#fee2e2',
    border: '#eb5757',
    iconColor: '#991b1b',
    textColor: '#991b1b',
  },
  [TrainingStatus.Expired]: {
    // Not used it for V1
    label: 'data-sources.training-status.expired',
  },
};

export const CONFIGS_BY_TRAINING_STATUS_V2: Record<
  TrainingStatus,
  { [key: string]: string }
> = {
  [TrainingStatus.Ready]: {
    fullLabel: 'data-sources.training-status.ready',
    shortLabel: 'data-sources.training-status.ready.short',
    bgColor: '#fef9c3',
    textColor: '#854d0e',
  },
  [TrainingStatus.InProgress]: {
    fullLabel: 'data-sources.training-status.in-progress',
    shortLabel: 'data-sources.training-status.in-progress.short',
    bgColor: '#dbeafe',
    textColor: '#0554e3',
  },
  [TrainingStatus.Completed]: {
    fullLabel: 'data-sources.training-status.completed',
    shortLabel: 'data-sources.training-status.completed.short',
    bgColor: '#dcfce7',
    textColor: '#166534',
  },
  [TrainingStatus.Failed]: {
    fullLabel: 'data-sources.training-status.failed',
    shortLabel: 'data-sources.training-status.failed.short',
    bgColor: '#fee2e2',
    textColor: '#991b1b',
  },
  [TrainingStatus.Expired]: {
    fullLabel: 'data-sources.training-status.expired',
    shortLabel: 'data-sources.training-status.expired.short',
    bgColor: '#f3f4f6',
    textColor: '#1f2937',
  },
};

export const ACCEPTED_FILE_TYPES: Record<string, string> = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'Excel (xlsx)',
  'text/csv': 'CSV',
  'application/vnd.ms-excel': 'CSV',
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'Word (docx)',
};
